import {HttpClient} from '@angular/common/http';
import {FoodType} from '../food/food';
import {Distribution, IDistDef} from '../board/distribution';
import {ILevelBase, Level as LevelBase} from '../../verliba-shared';

export interface ITeleport {
  x: number;
  y: number;
  dst?: number;
  group?: string;
  reverse?: boolean;
}

export interface ILevel extends ILevelBase {
  expiration?: number;
  food: number;
  grow: number;
  ports?: ITeleport[];
  menu?: IDistDef<FoodType>[];
  shift?: {x: number, y: number};
}

export class Level extends LevelBase<ILevel> {
  foodDistribution = new Distribution<FoodType>([
    {probability: 5, value: 'normal'},
    {probability: 1, value: 'shrink'},
    {probability: 1, value: 'life'},
  ]);

  constructor(level: string) {
    super(level);
  }

  async load(httpClient: HttpClient): Promise<void> {
    await super.load(httpClient);
    if (this.info.menu) {
      this.foodDistribution = new Distribution<FoodType>(this.info.menu);
    }
  }

  get foodType(): FoodType {
    return this.foodDistribution.random();
  }
}
